// Paletas de identidade visual por equipe.
// Seleção em build-time via VUE_APP_EQUIPE ("1" | "2").
// Fallback: Equipe 1.

export const PALETAS = {
  "1": {
    nome: "Equipe 1",
    topbar: "#216b80",
    primaria: "#2db8a9",
    primariaLight: "#4fd4c4",
    primariaLighter: "#7ae5d9",
    primariaDark: "#239b8f",
    primariaDarker: "#1a7d73",
    primariaRgb: "45, 184, 169",
    gradiente: "linear-gradient(135deg, #2db8a9 0%, #1a7d73 100%)",
    gradienteAnimado: "linear-gradient(-45deg, #2db8a9, #1a7d73, #239b8f, #4fd4c4)",
  },
  "2": {
    nome: "Equipe 2",
    topbar: "#01579b",
    primaria: "#0288d1",
    primariaLight: "#03a9f4",
    primariaLighter: "#4fc3f7",
    primariaDark: "#01579b",
    primariaDarker: "#002f6c",
    primariaRgb: "2, 136, 209",
    gradiente: "linear-gradient(135deg, #0288d1 0%, #002f6c 100%)",
    gradienteAnimado: "linear-gradient(-45deg, #0288d1, #002f6c, #01579b, #03a9f4)",
  },
};

export function temaAtual() {
  const id = process.env.VUE_APP_EQUIPE || "1";
  return PALETAS[id] || PALETAS["1"];
}

export function aplicarCssVars(elemento, tema) {
  elemento.style.setProperty("--cor-primaria", tema.primaria);
  elemento.style.setProperty("--cor-primaria-light", tema.primariaLight);
  elemento.style.setProperty("--cor-primaria-lighter", tema.primariaLighter);
  elemento.style.setProperty("--cor-primaria-dark", tema.primariaDark);
  elemento.style.setProperty("--cor-primaria-darker", tema.primariaDarker);
  elemento.style.setProperty("--cor-primaria-rgb", tema.primariaRgb);
  elemento.style.setProperty("--cor-primaria-gradiente", tema.gradiente);
  elemento.style.setProperty("--cor-primaria-gradiente-animado", tema.gradienteAnimado);
}
